export default __webpack_public_path__ + "static/media/icon-4-active.4298d6ab.svg";